// Modern JSX transform - React import not needed

/**
 * Simple SVG flag icons for language selection
 * Designed to be lightweight and accessible
 */

export const USFlag = ({ className = "w-10 h-7" }) => (
  <svg className={className} viewBox="0 0 40 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="28" rx="2" fill="#B22234"/>
    <rect y="2.15" width="40" height="2.15" fill="white"/>
    <rect y="6.46" width="40" height="2.15" fill="white"/>
    <rect y="10.77" width="40" height="2.15" fill="white"/>
    <rect y="15.08" width="40" height="2.15" fill="white"/>
    <rect y="19.38" width="40" height="2.15" fill="white"/>
    <rect y="23.69" width="40" height="2.15" fill="white"/>
    <rect width="16" height="12.31" rx="1" fill="#3C3B6E"/>
  </svg>
)

export const MexicoFlag = ({ className = "w-10 h-7" }) => (
  <svg className={className} viewBox="0 0 40 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="28" rx="2" fill="white"/>
    <rect width="13.33" height="28" fill="#006847"/>
    <rect x="26.67" width="13.33" height="28" fill="#CE1126"/>
    <circle cx="20" cy="14" r="3" fill="#A8751C"/>
  </svg>
)

export const CanadaFlag = ({ className = "w-10 h-7" }) => (
  <svg className={className} viewBox="0 0 40 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="28" rx="2" fill="white"/>
    <rect width="11" height="28" fill="#FF0000"/>
    <rect x="29" width="11" height="28" fill="#FF0000"/>
    <path d="M20 8L21 12H25L22 14L23 18L20 16L17 18L18 14L15 12H19L20 8Z" fill="#FF0000"/>
  </svg>
)

export const BrazilFlag = ({ className = "w-10 h-7" }) => (
  <svg className={className} viewBox="0 0 40 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="28" rx="2" fill="#009B3A"/>
    <path d="M20 4L35 14L20 24L5 14L20 4Z" fill="#FEDF00"/>
    <circle cx="20" cy="14" r="5" fill="#002776"/>
    <ellipse cx="20" cy="14" rx="6" ry="2" fill="white" opacity="0.9"/>
  </svg>
)

export const RussiaFlag = ({ className = "w-10 h-7" }) => (
  <svg className={className} viewBox="0 0 40 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    {/* Red field */}
    <rect width="40" height="28" rx="2" fill="#CC0000"/>
    {/* Gold bottom stripe */}
    <rect y="25.5" width="40" height="2.5" fill="#FFD700"/>
    {/* Star */}
    <path d="M8.5,1.5 L9.5,3.8 L12,3.9 L10.2,5.4 L10.8,7.8 L8.5,6.5 L6.2,7.8 L6.8,5.4 L5,3.9 L7.5,3.8 Z" fill="#FFD700"/>
    {/* Sickle blade */}
    <path d="M7,16.5 C6.5,12 9.5,9 13,9.5 C11,9.2 8.5,11 8.5,14.5 C8.5,17.5 10.5,19.5 13.5,19 L13,20 C9.5,20.5 7,18.5 7,16.5 Z" fill="#FFD700"/>
    {/* Sickle handle */}
    <path d="M13,19.5 L15.5,22.5 L14.5,23 L12,20 Z" fill="#FFD700"/>
    {/* Hammer head */}
    <path d="M8,12 L11,10 L12,12 L9,14 Z" fill="#FFD700"/>
    {/* Hammer handle */}
    <path d="M9.5,13.5 L14.5,22 L13.5,22.5 L8.5,14 Z" fill="#FFD700"/>
  </svg>
)

export const ChinaFlag = ({ className = "w-10 h-7" }) => (
  <svg className={className} viewBox="0 0 40 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="28" rx="2" fill="#DE2910"/>
    <path d="M12 6L13.2 9.5H17L14 11.5L15.2 15L12 13L8.8 15L10 11.5L7 9.5H10.8L12 6Z" fill="#FFDE00"/>
    <path d="M18 4L18.5 5.5H20L18.8 6.3L19.3 7.8L18 6.9L16.7 7.8L17.2 6.3L16 5.5H17.5L18 4Z" fill="#FFDE00"/>
    <path d="M20 8L20.5 9.5H22L20.8 10.3L21.3 11.8L20 10.9L18.7 11.8L19.2 10.3L18 9.5H19.5L20 8Z" fill="#FFDE00"/>
    <path d="M20 13L20.5 14.5H22L20.8 15.3L21.3 16.8L20 15.9L18.7 16.8L19.2 15.3L18 14.5H19.5L20 13Z" fill="#FFDE00"/>
    <path d="M18 17L18.5 18.5H20L18.8 19.3L19.3 20.8L18 19.9L16.7 20.8L17.2 19.3L16 18.5H17.5L18 17Z" fill="#FFDE00"/>
  </svg>
)

export const GermanyFlag = ({ className = "w-10 h-7" }) => (
  <svg className={className} viewBox="0 0 40 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="28" rx="2" fill="#000000"/>
    <rect y="9.33" width="40" height="9.34" fill="#DD0000"/>
    <rect y="18.67" width="40" height="9.33" fill="#FFCE00"/>
  </svg>
)

export const NetherlandsFlag = ({ className = "w-10 h-7" }) => (
  <svg className={className} viewBox="0 0 40 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="40" height="28" rx="2" fill="#AE1C28"/>
    <rect y="9.33" width="40" height="9.34" fill="#FFFFFF"/>
    <rect y="18.67" width="40" height="9.33" fill="#21468B"/>
  </svg>
)
